<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <h1 class="page__title text-center">{{ titlePage }}</h1>
        </CCardHeader>
        <CCardBody>
        </CCardBody>
    </CCard>
</template>

<script>
import pageMixin from "~/mixins/page.js";
export default {
    name: "DashboardMainAdminPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin],
    layout: "admin",

    mounted() {
        this.updatePageLoading(false);
    },
};
</script>

<style>
</style>